module.exports = __webpack_public_path__ + "img/Jeremiah-Chiu---Zoom-Room-1-p-800.49ec821b.jpg";